import { CloudRounded, SecurityRounded } from "@mui/icons-material";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import { Box, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { icons } from "../../../icons/iconExport";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const AzureStorageAccountDetailsView = ({ entityData }) => {
  const storageData = entityData?.azure_storage_account_data;

  if (!storageData) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {storageData?.resource_type && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <FolderOpenRoundedIcon sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Resource Type</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={storageData.resource_type}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {storageData?.resource_id && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serialNumberIcon} width="16px" />
            <Typography variant="subtitle2">Resource ID</Typography>
          </Box>
          <Box ml={2} display="flex">
            <Box display="flex" alignItems="center" gap={1}>
              <TextIntegrationStyle
                title=""
                value={storageData.resource_id}
              ></TextIntegrationStyle>
              <CustomCopyButton
                copyTitle="Resource ID"
                copyText={storageData.resource_id}
              />
            </Box>
          </Box>
        </Box>
      )}

      {storageData?.access_tier && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <CloudRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Access Tier</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={storageData.access_tier}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {(storageData?.encryption_key_source ||
        storageData?.minimum_tls_version) && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SecurityRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Security Settings</Typography>
          </Box>
          <Box ml={2} display="flex" flexDirection="column" gap={0.5}>
            {storageData?.encryption_key_source && (
              <TextIntegrationStyle
                title="Encryption Key Source"
                value={storageData.encryption_key_source}
              ></TextIntegrationStyle>
            )}
            {storageData?.minimum_tls_version && (
              <TextIntegrationStyle
                title="Minimum TLS Version"
                value={storageData.minimum_tls_version}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}

      {(storageData?.public_network_access ||
        storageData?.allow_blob_public_access !== undefined ||
        storageData?.allow_shared_key_access !== undefined) && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.networkIcon} width="16px" />
            <Typography variant="subtitle2">Network Access</Typography>
          </Box>
          <Box ml={2} display="flex" flexDirection="column" gap={0.5}>
            {storageData?.public_network_access && (
              <TextIntegrationStyle
                title="Public Network Access"
                value={storageData.public_network_access}
              ></TextIntegrationStyle>
            )}
            {storageData?.allow_blob_public_access !== undefined && (
              <TextIntegrationStyle
                title="Allow Blob Public Access"
                value={storageData.allow_blob_public_access ? "Yes" : "No"}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}

      {storageData?.is_hns_enabled !== undefined && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.databaseIcon} width="16px" />
            <Typography variant="subtitle2">Data Lake Features</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title="Hierarchical Namespace"
              value={storageData.is_hns_enabled ? "Enabled" : "Disabled"}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {(storageData?.primary_location || storageData?.secondary_location) && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.regionServerIcon} width="16px" />
            <Typography variant="subtitle2">Replication Locations</Typography>
          </Box>
          <Box ml={2} display="flex" flexDirection="column" gap={0.5}>
            {storageData?.primary_location && (
              <TextIntegrationStyle
                title="Primary"
                value={`${storageData.primary_location}${
                  storageData.status_of_primary
                    ? ` (${storageData.status_of_primary})`
                    : ""
                }`}
              ></TextIntegrationStyle>
            )}
            {storageData?.secondary_location && (
              <TextIntegrationStyle
                title="Secondary"
                value={`${storageData.secondary_location}${
                  storageData.status_of_secondary
                    ? ` (${storageData.status_of_secondary})`
                    : ""
                }`}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AzureStorageAccountDetailsView;
